import React from 'react';
import Navbar from '../components/Navbar';
import { Card, CardContent } from '../components/ui/card';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="privacy-policy">
      <Navbar />

      <div className="pt-24 pb-12">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="font-heading text-4xl font-bold text-slate-900 mb-2">Privacy Policy</h1>
          <p className="text-slate-500 mb-8">Last updated: January 2026</p>

          <Card className="border-slate-200">
            <CardContent className="p-8 prose prose-slate max-w-none">
              <h2>1. Information We Collect</h2>
              <p>We collect information you provide directly to us, such as when you create an account, make a purchase, or contact us for support.</p>
              <ul>
                <li><strong>Account Information:</strong> Name, email address, password</li>
                <li><strong>Payment Information:</strong> Processed securely through Stripe (we do not store card details)</li>
                <li><strong>Course Progress:</strong> Your learning activity and progress data</li>
                <li><strong>Communications:</strong> Messages you send through our contact form</li>
              </ul>

              <h2>2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide, maintain, and improve our services</li>
                <li>Process transactions and send related information</li>
                <li>Send you technical notices and support messages</li>
                <li>Respond to your comments and questions</li>
                <li>Send promotional communications (with your consent)</li>
              </ul>

              <h2>3. Information Sharing</h2>
              <p>We do not sell, trade, or otherwise transfer your personal information to third parties except:</p>
              <ul>
                <li>With service providers who assist in our operations (Stripe for payments)</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights and prevent fraud</li>
              </ul>

              <h2>4. Data Security</h2>
              <p>We implement appropriate security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure.</p>

              <h2>5. Cookies</h2>
              <p>We use cookies to enhance your experience, analyze site traffic, and for authentication purposes. You can control cookies through your browser settings.</p>

              <h2>6. Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion of your data</li>
                <li>Opt-out of marketing communications</li>
              </ul>

              <h2>7. Children's Privacy</h2>
              <p>Our services are not intended for children under 13. We do not knowingly collect information from children under 13.</p>

              <h2>8. Changes to This Policy</h2>
              <p>We may update this policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>

              <h2>9. Contact Us</h2>
              <p>If you have questions about this Privacy Policy, please contact us at:</p>
              <p><strong>Email:</strong> info@aiskillflowpro.com</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
